import { ExamReportRankingType } from '../../api/exam-report';
import classNames from 'classnames';
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid';

export type RankingTablePropsType = {
  examReports: ExamReportRankingType[];
  studentId: number;
};

function ExamRankingTable({ examReports, studentId }: RankingTablePropsType) {
  const hasScaledScore = !!examReports[0].scaledScore;
  let [lastRank, lastRankCount] = [0, 0];

  return (
    <figure className='my-8'>
      <table className='mx-auto w-full max-w-4xl table-fixed border-collapse border border-zinc-400 text-sm'>
        <thead className='bg-zinc-300'>
          <tr className='border border-zinc-400'>
            {['رتبه', 'نام مستعار', 'درصد'].map(header => (
              <th
                key={header}
                className='whitespace-nowrap border border-zinc-400 p-1 text-center font-semibold xs:p-3'
              >
                {header}
              </th>
            ))}
            {hasScaledScore && (
              <th className='whitespace-nowrap border border-zinc-400 p-1 text-center font-semibold xs:p-3'>
                تراز
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {examReports.map((examReport: ExamReportRankingType) => {
            const hasSpace = lastRank > 0 && examReport.rank > lastRank + lastRankCount;
            if (lastRank === examReport.rank) {
              lastRankCount++;
            } else {
              lastRankCount = 1;
              lastRank = examReport.rank;
            }

            return (
              <>
                {hasSpace && (
                  <tr key={examReport.id} className='border bg-zinc-100'>
                    <td
                      colSpan={hasScaledScore ? 4 : 3}
                      className='cursor-context-menu border border-zinc-400 p-1 text-center font-bold xs:p-3'
                    >
                      <EllipsisVerticalIcon width={20} height={20} className='mx-auto' />
                    </td>
                  </tr>
                )}
                <tr
                  key={examReport.id}
                  className={classNames('border', {
                    'bg-blue-100': examReport.student.id === studentId
                  })}
                >
                  <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>
                    {examReport.rank}
                  </td>
                  <td className='ltr border border-zinc-400 p-1 text-center font-bold xs:p-3'>
                    {examReport.student.nickname}
                  </td>
                  <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>
                    {examReport.score}%
                  </td>
                  {hasScaledScore && (
                    <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>
                      {examReport.scaledScore}
                    </td>
                  )}
                </tr>
              </>
            );
          })}
        </tbody>
      </table>
    </figure>
  );
}

export default ExamRankingTable;
